import auth from './auth';
import cohort from './cohort';
import collaboration from './collaboration';
import dashboard from './dashboard';
import dataSummary from './dataSummary';
import datasetManager from './datasetManager';
import datasetSummary from './datasetSummary';
import cohortManager from './cohortManager';
import dataExplorer from './dataExplorer';
import analysisSummary from './analysisSummary';
import notifications from './notifications';

export default {
  auth,
  cohort,
  collaboration,
  dashboard,
  dataSummary,
  datasetManager,
  datasetSummary,
  cohortManager,
  dataExplorer,
  analysisSummary,
  notifications,
};
